import React, { useEffect, useState } from 'react';
import { RouterProvider } from 'react-router-dom';
import router from '@/routes';
import { ConfigProvider } from 'antd';
import { resources } from '@/i18n/index';
import { theme } from '@/constants/customTheme';
import { useStore } from '@/stores';
import type { Locale } from 'antd/es/locale';
import { autorun } from 'mobx';
interface langObj {
  [key: string]: unknown;
}
const App: React.FC = () => {
  const { locale } = useStore();
  const langObj: langObj = {
    ...resources
  };
  const [currentLang, setCurrentLang] = useState<string>(locale.lang);
  useEffect(() => {
    const dispose = autorun(() => {
      setCurrentLang(locale.lang);
    });

    return () => dispose();
  }, [locale.lang]);

  return (
    <ConfigProvider
      theme={{ ...theme }}
      locale={langObj[currentLang] as Locale}
    >
      <RouterProvider router={router} />
    </ConfigProvider>
  );
};

export default App;
